"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalEvents = void 0;
var GalEvents;
(function (GalEvents) {
    GalEvents["CancelDTO"] = "CancelDTO";
    GalEvents["EmailSignupDTO"] = "EmailSignupDTO";
    GalEvents["EmailVerificationCompleteDTO"] = "EmailVerificationCompleteDTO";
    GalEvents["EmailVerificationSendDTO"] = "EmailVerificationSendDTO";
    GalEvents["ErrorDTO"] = "ErrorDTO";
    GalEvents["GameDownloadDTO"] = "GameDownloadDTO";
    GalEvents["GameDownloadCompleteDTO"] = "GameDownloadCompleteDTO";
    GalEvents["GameDownloadStartDTO"] = "GameDownloadStartDTO";
    GalEvents["GameGiveAllowanceDTO"] = "GameGiveAllowanceDTO";
    GalEvents["GameInstallCompleteDTO"] = "GameInstallCompleteDTO";
    GalEvents["GameInstallQueueDTO"] = "GameInstallQueueDTO";
    GalEvents["GameInstallStartDTO"] = "GameInstallStartDTO";
    GalEvents["GameplayBeginDTO"] = "GameplayBeginDTO";
    GalEvents["GameUpdateCompleteDTO"] = "GameUpdateCompleteDTO";
    GalEvents["GameUpdateStartDTO"] = "GameUpdateStartDTO";
    GalEvents["LauncherAgreementAcceptDTO"] = "LauncherAgreementAcceptDTO";
    GalEvents["LauncherCheckInstalledGamesCompleteDTO"] = "LauncherCheckInstalledGamesCompleteDTO";
    GalEvents["LauncherCheckInstalledGamesStartDTO"] = "LauncherCheckInstalledGamesStartDTO";
    GalEvents["LauncherConnectionCompleteDTO"] = "LauncherConnectionCompleteDTO";
    GalEvents["LauncherConnectionStartDTO"] = "LauncherConnectionStartDTO";
    GalEvents["LauncherConnectionCloseDTO"] = "LauncherConnectionCloseDTO";
    GalEvents["LauncherDownloadStartDTO"] = "LauncherDownloadStartDTO";
    GalEvents["LauncherSetVersionDTO"] = "LauncherSetVersionDTO";
    GalEvents["LauncherUpdateCompleteDTO"] = "LauncherUpdateCompleteDTO";
    GalEvents["LauncherUpdateStartDTO"] = "LauncherUpdateStartDTO";
    GalEvents["LoginDTO"] = "LoginDTO";
    GalEvents["LogoutDTO"] = "LogoutDTO";
    GalEvents["NavigateDTO"] = "NavigateDTO";
    GalEvents["PageViewDTO"] = "PageViewDTO";
    GalEvents["PressDTO"] = "PressDTO";
    GalEvents["PurchaseAttemptDTO"] = "PurchaseAttemptDTO";
    GalEvents["PurchaseCompleteDTO"] = "PurchaseCompleteDTO";
    GalEvents["PurchaseFulfillDTO"] = "PurchaseFulfillDTO";
    GalEvents["RegisterDTO"] = "RegisterDTO";
    GalEvents["SessionPingDTO"] = "SessionPingDTO";
    GalEvents["SessionStartDTO"] = "SessionStartDTO";
    GalEvents["TwoFactorChallengeDTO"] = "TwoFactorChallengeDTO";
    GalEvents["TwoFactorSetupDTO"] = "TwoFactorSetupDTO";
    GalEvents["TwoFactorVerifyDTO"] = "TwoFactorVerifyDTO";
    GalEvents["UninformedErrorDTO"] = "UninformedErrorDTO";
    GalEvents["WalletCreateDTO"] = "WalletCreateDTO";
})(GalEvents = exports.GalEvents || (exports.GalEvents = {}));
